import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Route: /phonepe — no rendering, just redirects by phonepe* session state.
const PhonepeEntry = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const loginEmail = localStorage.getItem('phonepeLoginEmail');
    const company = localStorage.getItem('phonepeCompany');
    if (loginEmail && company) {
      navigate('/phonepe/dashboard', { replace: true });
    } else {
      navigate('/phonepe/login', { replace: true });
    }
  }, [navigate]);

  return null;
};

export default PhonepeEntry;
